import { Record } from "immutable";

import outlineColumnIds from "../../../../constants/outlineColumnIds";
import createFromJS from "../../../createFromJS";
import { defaultColumnsForSpreadsheetView } from "./defaultColumnsForSpreadsheetView";

export const SpreadsheetViewOptionsRecord = Record({
  columns: defaultColumnsForSpreadsheetView,
  sortBy: outlineColumnIds.sequence,
  sortInDesc: false
});

const data = {
  collections: {
    columns: "TableViewColumnRecord"
  }
};
createFromJS.registerCallback(
  "SpreadsheetViewOptionsRecord",
  createFromJS.createNestedCallback(SpreadsheetViewOptionsRecord, data)
);
